<template>
	<v-dialog
		v-if="gridView && parentItem"
		v-model="showDialog"
		width="600"
		min-height="400"
		persistent
		scrollable
	>
		<v-card>
			<v-card-text>
				<v-select
					label="Connector"
					v-model="selectedConnector"
					:items="connectors"
					item-text="Name"
				/>
				<table v-if="parentItem" style="width: 100%; height: 1px">
					<thead>
						<tr>
							<td align="center" colspan="2">
								<div
									v-if="parentHeaders"
									:style="getColorStyle(parentItem)"
								>
									<v-chip
										class="ma-1"
										v-for="(header, index) in parentHeaders"
										v-bind:key="index"
									>
										{{
											getConnectorHeaderLabel(
												header,
												parentItem
											)
										}}:{{
											getConnectorHeaderValue(
												header,
												parentItem
											)
										}}
									</v-chip>
								</div>
							</td>
						</tr>
					</thead>
					<tbody v-if="childrenItems && childrenItems.length > 0">
						<tr v-for="index in getSize()" v-bind:key="index">
							<td>RU {{ index }}</td>
							<td
								align="center"
								v-if="getChild(index)"
								:rowspan="getChildRowSpan(getChild(index))"
							>
								<div
									v-if="getChild(index) && childHeaders"
									:style="getColorStyle(getChild(index))"
								>
									<v-chip
										class="ma-1"
										v-for="(header, key) in childHeaders"
										v-bind:key="key"
									>
										{{
											getConnectorHeaderLabel(
												header,
												getChild(index)
											)
										}}:{{
											getConnectorHeaderValue(
												header,
												getChild(index)
											)
										}}
									</v-chip>
								</div>
							</td>
							<td v-else-if="indexHasChild(index)" />
						</tr>
					</tbody>
					<tbody v-else>
						<tr v-for="index in getSize()" v-bind:key="index">
							<td colspan="2">RU {{ index }}</td>
						</tr>
					</tbody>
				</table>
			</v-card-text>

			<v-card-actions>
				<v-spacer />
				<v-btn @click.stop="onClose">Close</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import gridViewConnctorsMixin from '../../../mixins/gridViewConnectors/gridViewConnectorsMixin';
import gridViewDataService from '../../../services/data/projectGridsService';
import { GeneralActions } from '../../../store/actions';
import { gridViewConnectorFilterType } from '../../../enums/gridViewConnectorFilterType';
import { gridViewConnectorHeaderType } from '../../../enums/gridViewConnectorHeaderType';
export default {
	name: 'GridViewConnectosModal',
	props: {
		showDialog: Boolean,
		gridView: Object,
		parentItem: Object,
	},
	mixins: [gridViewConnctorsMixin],
	computed: {
		connectors() {
			if (!this.parentItem) return [];
			return this.gridItemConnectors(this.parentItem);
		},
		parentHeaders() {
			if (!this.selectedConnector) return [];
			if (!this.selectedConnector.GridViewConnectorHeaders) return [];
			return this.selectedConnector.GridViewConnectorHeaders.filter(
				(x) => x.HeaderType == gridViewConnectorHeaderType.Parent
			);
		},
		childHeaders() {
			if (!this.selectedConnector) return [];
			if (!this.selectedConnector.GridViewConnectorHeaders) return [];
			let result = this.selectedConnector.GridViewConnectorHeaders.filter(
				(x) => x.HeaderType == gridViewConnectorHeaderType.Child
			);
			return result;
		},
	},
	data() {
		return {
			selectedConnector: null,
			childrenItems: [],
		};
	},
	watch: {
		selectedConnector() {
			this.childrenItems = [];
			this.loadChildrenItems();
		},
	},
	mounted() {
		if (this.connectors && this.connectors.length > 0) {
			this.selectedConnector = this.connectors[0];
		}
	},
	methods: {
		onClose() {
			this.$emit('close');
		},

		loadChildrenItems() {
			let payload = {
				ViewId: this.gridView.Id,
				RowsPerPage: 0,
				Page: 1,
				Columns: this.gridView.Columns.map((x) => x.Id),
				AdvancedFilter: this.buildAdvancedFilter(),
				IncludeCount: true,
			};

			this.$store.dispatch(GeneralActions.LOADING, true);
			gridViewDataService
				.loadData(payload)
				.then((resp) => {
					this.childrenItems = resp.data.Data;
				})
				.catch((error) => {
					this.$store.dispatch(GeneralActions.ERROR, error);
				})
				.finally(() => {
					this.$store.dispatch(GeneralActions.LOADING, false);
				});
		},

		buildAdvancedFilter() {
			let filters =
				this.selectedConnector.GridViewConnectorFilters.filter(
					(x) =>
						x.GridViewConnectorFilterType ==
						gridViewConnectorFilterType.Child
				);
			if (filters.length <= 0) return null;
			let result = { Operator: 1, Filters: [] };
			filters.forEach((f) => {
				let value = f.Value;
				if (f.ValueGridViewFieldId) {
					let key = this.getGridViewFieldKeyById(
						f.ValueGridViewFieldId
					);
					value = this.parentItem[key];
				}
				let filterItem = {
					Value: value,
					Operator: f.FilterOperator,
					FieldId: f.FilterGridViewFieldId,
				};
				result.Filters.push(filterItem);
			});
			return result;
		},
		getConnectorHeaderValue(header, item) {
			if (!header) return null;
			if (!item) return null;
			let key = this.getGridViewFieldKeyById(header.GridViewFieldId);
			return item[key];
		},

		getConnectorHeaderLabel(header, item) {
			if (!header) return null;
			if (!item) return null;
			let gvf = this.gridView.Columns.find(
				(x) => x.Id == header.GridViewFieldId
			);
			if (gvf) return gvf.Label;
			return '';
		},

		getColorStyle(item) {
			let color = 'transparent';
			if (
				item &&
				this.selectedConnector &&
				this.selectedConnector.ColorGvfId
			) {
				let key = this.getGridViewFieldKeyById(
					this.selectedConnector.ColorGvfId
				);
				if (key && item[key]) color = item[key];
			}

			return 'background:' + color;
		},

		getSize() {
			if (
				this.selectedConnector &&
				this.selectedConnector.ParentSizeGvfId
			) {
				let key = this.getGridViewFieldKeyById(
					this.selectedConnector.ParentSizeGvfId
				);
				if (key && this.parentItem[key]) return this.parentItem[key];
			}
			return 0;
		},

		getChild(index) {
			let result = null;
			if (
				index &&
				this.selectedConnector &&
				this.selectedConnector.ChildTopGvfId &&
				this.childrenItems &&
				this.childrenItems.length > 0
			) {
				let key = this.getGridViewFieldKeyById(
					this.selectedConnector.ChildTopGvfId
				);
				let validChild = [];
				this.childrenItems.forEach((child) => {
					if (child[key] == index) validChild.push(child);
				});
				if (validChild.length > 0) result = validChild[0];
			}
			return result;
		},

		getChildRowSpan(child) {
			if (
				child &&
				this.selectedConnector &&
				this.selectedConnector.ChildTopGvfId &&
				this.selectedConnector.ChildBottomGvfId
			) {
				let topKey = this.getGridViewFieldKeyById(
					this.selectedConnector.ChildTopGvfId
				);
				let bottomKey = this.getGridViewFieldKeyById(
					this.selectedConnector.ChildBottomGvfId
				);
				if (child[bottomKey] && child[topKey]) {
					let result =
						parseInt(child[bottomKey]) -
						parseInt(child[topKey]) +
						1;
					return result;
				}
			}
			return 1;
		},

		indexHasChild(index) {
			let result = [];
			if (
				this.childrenItems &&
				this.selectedConnector &&
				this.selectedConnector.ChildTopGvfId &&
				this.selectedConnector.ChildBottomGvfId
			) {
				let topKey = this.getGridViewFieldKeyById(
					this.selectedConnector.ChildTopGvfId
				);
				let bottomKey = this.getGridViewFieldKeyById(
					this.selectedConnector.ChildBottomGvfId
				);
				this.childrenItems.forEach((child) => {
					let bottom = parseInt(child[bottomKey]);
					let top = parseInt(child[topKey]);
					if (index > top && index <= bottom) result.push(child);
				});
			}
			return result.length == 0;
		},
	},
};
</script>

<style lang="scss" scoped>
td {
	border: dashed;
	padding: 4px;
	div {
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
}
</style>
